document.addEventListener('DOMContentLoaded', () => {
    const postGrid = document.querySelector('.bds-postgrid__cards');
    if (!postGrid) return;

    var colc = new Colcade(postGrid, {
        columns: '.bds-postgrid__cards-col',
        items: '.bds-postgrid__card',
    });

});
